import React from "react";
import { Props } from "../types";

function RichTextIcon(props: Props) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="currentColor"
      className={props.className}
      style={props.style}
    >
      <rect x="0" fill="none" width="20" height="20" />
      <path d="M14.5 3v2H2V3h12.5zM2 7h10v2H2V7zm0 4h6v2H2v-2zm0 4h8v2H2v-2zm14.4-5.7c-.4-.4-1-.4-1.4 0l-5 5V17h2.7l5-5c.4-.4.4-1 0-1.4l-1.3-1.3zm-4.7 6.4l-.4-.4 3.3-3.3.4.4-3.3 3.3z" />
    </svg>
  );
}

export { RichTextIcon };
